export enum FocusedFieldAttribute {
  GLOBAL_products_name_5_1_5 = 'GLOBAL.products.name.5_1_5',
  GLOBAL_products_name_6_7_1 = 'GLOBAL.products.name.6_7_1',
  GLOBAL_products_name_11_3_1 = 'GLOBAL.products.name.11_3_1',
  GLOBAL_products_price_5_1_5 = 'GLOBAL.products.price.5_1_5',
  GLOBAL_products_price_11_3_1 = 'GLOBAL.products.price.11_3_1',
  GLOBAL_products_monthlySalesPlanPhysical_5_1_5 = 'GLOBAL.products.monthlySalesPlanPhysical.5_1_5',
  GLOBAL_products_monthlySalesPlanPhysical_6_7_1 = 'GLOBAL.products.monthlySalesPlanPhysical.6_7_1',
  GLOBAL_products_annualSalesGrowthRate_5_1_5 = 'GLOBAL.products.annualSalesGrowthRate.5_1_5',
  GLOBAL_products_annualSalesGrowthRate_6_7_1 = 'GLOBAL.products.annualSalesGrowthRate.6_7_1',
  GLOBAL_products_annualSalesGrowthRate_11_3_1 = 'GLOBAL.products.annualSalesGrowthRate.11_3_1',
  GLOBAL_products_annualPriceGrowthRate_11_3_1 = 'GLOBAL.products.annualPriceGrowthRate.11_3_1',
  GLOBAL_totalCost_1_7_1 = 'GLOBAL.totalCost.1_7_1',
  GLOBAL_totalCost_9_2 = 'GLOBAL.totalCost.9_2',
  otherIncome = 'FINANCIAL_PLAN.revenuePlan.otherIncomePlannedProductsVolume',
  financialIncome = 'FINANCIAL_PLAN.profitAndLossProjection.netIncome.financialIncome',
  nonOperationIncome = 'FINANCIAL_PLAN.profitAndLossProjection.netIncome.nonOperatingIncome',
  calendarPlanTable = 'FINANCIAL_PLAN.cashFlowElements.calendarPlan.table',
  loanRepaymentScheduleTable = 'FINANCIAL_PLAN.cashFlowElements.loanRepaymentSchedule.table',
  fundingDirectionsTable = 'FINANCIAL_PLAN.cashFlowElements.fundingDirections.table',
  purchaseNonCurrentAssets = 'FINANCIAL_PLAN.projectedCashFlow.direct.cashFLowsInvestingActivities.table.0',
  purchaseOfInvestment = 'FINANCIAL_PLAN.projectedCashFlow.direct.cashFLowsInvestingActivities.table.1',
  salePPE = 'FINANCIAL_PLAN.projectedCashFlow.direct.cashFLowsInvestingActivities.table.2',
  saleOfInvestment = 'FINANCIAL_PLAN.projectedCashFlow.direct.cashFLowsInvestingActivities.table.3',
  governmentGrants = 'FINANCIAL_PLAN.projectedCashFlow.direct.cashFLowsInvestingActivities.table.4',
  repurchaseCompanyShares = 'FINANCIAL_PLAN.projectedCashFlow.direct.cashFLowsFinancingActivities.table.0',
  dividendsPaid = 'FINANCIAL_PLAN.projectedCashFlow.direct.cashFLowsFinancingActivities.table.1',
  monthlyExpenses = 'FINANCIAL_PLAN.plannedExpenses.monthlyExpenses',
  costOfEachUnitTable = 'FINANCIAL_PLAN.plannedExpenses.costOfEachUnit.costOfEachUnitTable',
  expensesTable = 'FINANCIAL_PLAN.plannedExpenses.totalExpenses.expensesTable',
  constOfSalesTable = 'FINANCIAL_PLAN.plannedExpenses.costOfSales.costOfSalesTable',
  rAndDTable = 'FINANCIAL_PLAN.plannedExpenses.r&D.rAndDTable',
  salesAndMarketingTable = 'FINANCIAL_PLAN.plannedExpenses.salesAndMarketing.salesAndMarketingTable',
  generalAndAdministrativeTable = 'FINANCIAL_PLAN.plannedExpenses.generalAndAdministrative.generalAndAdministrativeTable',
  personnelExpensesTable = 'FINANCIAL_PLAN.plannedExpenses.personnelExpenses.personnelExpensesTable',
}
